import React from 'react';

const MentionPopup = ({ users, onSelect }) => {
    console.log("🚀 ~ MentionPopup ~ users:", users)
    if (!users.length) return null;


    return (
        <>
            <ul
                className={`absolute z-50 bg-white border dark:border-none rounded shadow h-auto max-h-48 overflow-auto w-60 bottom-[64px] right-0 bgSurfaceDarkMainBox`}>
                {users?.map((user) => (
                    <li
                        key={user.url}
                        className="px-4 py-1.5 hover:bg-gray-100 cursor-pointer text-sm text-teal-600 dark:text-teal-400"
                        onMouseDown={() => onSelect(user)}
                    >
                        {user.text}
                    </li>
                ))}
            </ul>
        </>
    );
};

export default MentionPopup;
